import { profileTh } from "@/module/Profile/locale/ProfileLocaleTh.js";

export const th = {
	default: {
		search: 'ค้นหา',
		confirm: 'ยืนยัน',
		ok: 'ตกลง',
		cancel: 'ยกเลิก',
	},
	profile: profileTh,
	date: {
		days: 'วัน',
		months: 'เดือน',
		years: 'ปี',
		minutes: 'นาที',
		minutes_short: 'น.',
		hours: 'ชั่วโมง',
		hours_short: 'ช.ม.',
		date_flase: 'กรุณาระบุวันเกิด',
		month_full: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
		month_short: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
		month_full_arr: [{ strvalue: "01", strtext: 'มกราคม' },
		{ strvalue: '02', strtext: 'กุมภาพันธ์' },
		{ strvalue: '03', strtext: 'มีนาคม' },
		{ strvalue: '04', strtext: 'เมษายน' },
		{ strvalue: '05', strtext: 'พฤษภาคม' },
		{ strvalue: '06', strtext: 'มิถุนายน' },
		{ strvalue: '07', strtext: 'กรกฎาคม' },
		{ strvalue: '08', strtext: 'สิงหาคม' },
		{ strvalue: '09', strtext: 'กันยายน' },
		{ strvalue: '10', strtext: 'ตุลาคม' },
		{ strvalue: '11', strtext: 'พฤศจิกายน' },
		{ strvalue: '12', strtext: 'ธันวาคม' }]
	},
	confirm_redeem: {
		confirm: "ยืนยัน",
		cancel: "ยกเลิก",
		confirmBodyText: "ใช้ {pointText} คะแนน เพื่อรับสิทธิ์ชิงโชค 1 สิทธิ์",
		confirmBodyHeader: "ยืนยันการรับสิทธิ์ชิงโชค",
		headline: 'ยืนยัน',
		free: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
		free_no_timer: 'ยืนยันการรับสิทธิ์',
		free_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
		draw: 'ยืนยันเพื่อเข้าร่วมสนุก <br/> ประกาศผู้ชนะหลังวันที่ {0}',
		draw_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
		deal: 'รหัสจะมีอายุ {0} หลังการยืนยัน',
		deal_no_timer: 'ยืนยันการรับสิทธิ์',
		deal_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
		buy: 'ยืนยันการซื้อ',
		buy_delivery: 'กรุณากรอกที่อยู่จัดส่ง',
		interface: 'ยืนยันเพื่อเข้าสู่เว็บไซต์ที่ร่วมรายการ',
	},
	redeem_button: {
		default: 'กดรับสิทธิ์',
		none: '',
		soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
		soldOutBuy: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
		maxPerPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
		redeemCoolDown: 'ขออภัย คุณได้รับ Campaign นี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
		nextDate: 'รับสิทธิ์ครั้งต่อไปได้<br/>ตั้งแต่ : ',
		exceedBuyPointLimitPerday: '',
		conditionIsInvalid: 'คุณต้องทำตามเงื่อนไขที่ระบุไว้ใน Campaign นี้ก่อนจึงสามารถกดรับได้ กรุณาอ่านเพิ่มเติมในรายละเอียด',
		campaignExpired: 'สินค้านี้หมดอายุแล้ว',
		campaignExpiredBuy: 'สินค้านี้หมดอายุแล้ว',
		campaignNotAvailable: 'สิทธิพิเศษนี้ไม่สามารถรับได้ในตอนนี้',
		campaignNotAvailableBuy: 'สินค้านี้ไม่สามารถรับได้ในตอนนี้',
		notEnoughPoint: 'คะแนนของคุณไม่เพียงพอที่จะแลกรับสิทธิ์',
		notSupport: 'ไม่รองรับแคมเปญประเภทนี้'
	},
	after_redeem: {
		titleSuccess: 'แลกสิทธ์ชิงโชคเรียบร้อยแล้ว',
		btnText: "ปิด",
		titleFail: {
			noPoint: 'คะแนนไม่เพียงพอสำหรับการแลกรับสิทธิ์',
			soldOut: 'ขออภัย มีผู้ใช้สิทธิ์เต็มจำนวนแล้ว',
			maxPerson: 'ขออภัย คุณได้แลกรับสิทธิ์นี้แล้ว',
			interval: 'ขออภัย คุณได้รับแคมเปญนี้ไปแล้ว กรุณารอกดรับใหม่อีกครั้งภายหลัง',
			expire: 'แคมเปญหมดอายุแล้ว'
		}
	},
	purchase: {
		show_code: 'กดเพื่อดูรหัส',
		code_expired: 'รหัสหมดอายุ',

		delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',
		shipped: 'สินค้าได้ถูกจัดส่งเรียบร้อยแล้ว',
		parcel_no: 'พัสดุเลขที่',

		not_draw1: 'รางวัลนี้ยังไม่ได้ประกาศรายชื่อผู้โชคดี',
		not_draw2: 'กรุณากลับมาตรวจสอบใหม่ภายหลัง',
		draw_winner1: 'ขอแสดงความยินดีด้วยค่ะ',
		draw_winner2: 'คุณเป็นผู้โชคดีได้รับของรางวัล',
		draw_not_win1: 'ขออภัย คุณไม่ใช่ผู้โชคดีได้รับของรางวัลนี้',
		draw_not_win2: 'กรุณาร่วมสนุกกันใหม่ในครั้งหน้า',
	},
	serial: {
		close_btn: 'ปิด',
		show_code_at_shop: 'กรุณาแสดงรหัสนี้ ให้แก่ร้านค้า',

		delivery: 'สินค้าจะถูกจัดส่งตามเงื่อนไขของแคมเปญ',

		draw: 'ขอบคุณที่ร่วมสนุกกับเรา<br/>กรุณาติดตามประกาศผล หลังจากวันที่ {0}',
		draw_after: 'หลังจากวันที่',

		qr_code: 'QR Code',
		barcode: 'Barcode',
		code: 'Code',

		expire_in: 'หมดเวลาใน ',
		code_expired: 'รหัสหมดอายุ',

		redeem_on: 'รับสิทธิ์เมื่อ {0}'
	},
	shipping: {
		headline: 'ที่อยู่จัดส่ง',

		firstname: {
			name: 'ชื่อ',
			placeholder: 'ชื่อ',
			required: 'กรุณากรอกชื่อ',
			too_short: '',
			invalid: '',
		},
		lastname: {
			name: 'นามสกุล',
			placeholder: 'นามสกุล',
			required: 'กรุณากรอกนามสกุล',
			too_short: '',
			invalid: '',
		},
		address: {
			name: 'ที่อยู่',
			placeholder: 'กรุณากรอกที่อยู่',
			required: 'กรุณากรอกที่อยู่',
			too_short: '',
			invalid: '',
		},
		contactnumber: {
			name: 'เบอร์โทรศัพท์',
			placeholder: 'เบอร์โทรศัพท์',
			required: 'กรุณากรอกเบอร์โทรศัพท์',
			too_short: 'เบอร์โทรศัพท์ต้องมี {0} หลัก',
			invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
		},
		nationalid: {
			name: 'เลขประจำตัวประชาชน',
			placeholder: 'เลขประจำตัวประชาชน',
			required: 'กรุณากรอกเลขประจำตัวประชาชน',
			too_short: 'เลขประจำตัวประชาชนต้องมี {0} หลัก',
			invalid: 'เลขประจำตัวประชาชนไม่ถูกต้อง',
		},
		email: {
			name: 'อีเมล',
			placeholder: 'อีเมล',
			required: 'กรุณากรอกอีเมล',
			too_short: '',
			invalid: 'อีเมลไม่ถูกต้อง',
		},
		zipcode: {
			name: 'รหัสไปรษณีย์',
			placeholder: 'รหัสไปรษณีย์',
			required: 'กรุณากรอกรหัสไปรษณีย์',
			too_short: 'รหัสไปรษณีย์ต้องมี {0} หลัก',
			invalid: 'รหัสไปรษณีย์ไม่ถูกต้อง',
		},
		subdistrict: {
			name: 'เขต/ตำบล',
			placeholder: 'กรุณาเลือกเขต/ตำบล',
			required: 'กรุณาเลือกเขต/ตำบล',
			too_short: '',
			invalid: '',
		},
		district: {
			name: 'แขวง/อำเภอ',
			placeholder: 'กรุณาเลือกแขวง/อำเภอ',
			required: 'กรุณาเลือกแขวง/อำเภอ',
			too_short: '',
			invalid: '',
		},
		province: {
			name: 'จังหวัด',
			placeholder: 'กรุณาเลือกจังหวัด',
			required: 'กรุณาเลือกจังหวัด',
			too_short: '',
			invalid: '',
		},

		save_address: 'บันทึกที่อยู่เพื่อใช้รับสิทธิ์ครั้งต่อไป',
		save_address_buy: 'บันทึกที่อยู่เพื่อใช้ในการสั่งซื้อครั้งต่อไป',

		confirm_btn: 'ยืนยัน',
		cancel_btn: 'ยกเลิก',

		alert_headline: 'ที่อยู่จัดส่ง',
		alert_ok_btn: 'ตกลง',
	},
	main: {
		home_page: "หน้าแรก",
		login: "เข้าสู่ระบบ",
		campaign: "แคมเปญ",
		category: 'หมวดหมู่',
		map: "แผนที่",
		terms: "Terms And Conditions",
		history: 'ประวัติรับสิทธิ์',
		profile: "โปรไฟล์",
		logout: "ออกจากระบบ",
		lang: "ภาษา",
		msgLogout: "ต้องการออกจากระบบ",
		cancel: "ยกเลิก",
	},
	campaign: {
		point: 'คะแนน',
		get_point: 'ได้คะแนน : ',
		use_point: 'ใช้คะแนน : ',
	},
	detail: {
		detail: 'รายละเอียด',
		condition: 'เงื่อนไข',

		point: 'คะแนน',
		get_point: 'ได้คะแนน : ',
		use_point: 'ใช้คะแนน : ',
		available_date: 'แลกได้วันที่',

		color: {
			name: 'สี',
			placeholder: 'กรุณาเลือกสี',
			required: 'กรุณาเลือกสี',
		},
		size: {
			name: 'ขนาด',
			placeholder: 'กรุณาเลือกขนาด',
			required: 'กรุณาเลือกขนาด',
		},
	},
	history: {
		point: 'คะแนน',
		get_point: 'ได้คะแนน : ',
		use_point: 'ใช้คะแนน : ',

		parcel_number: 'เลขพัสดุ : ',
	},
	home: {
		seeDetailModal: {
			btnClose: 'ปิด',
			title: 'รายละเอียดของรางวัล',
		},
		otherConditionModal: {
			btnClose: 'ปิด',
			title: 'เงื่อนไขการร่วมรายการ',
			body: `
          <p>
            1. บริษัทขอสงวนสิทธิ์การร่วมรายการเฉพาะผู้เป็นสมาชิกเมกา สไมล์
            รีวอร์ดสโดยการลงทะเบียนจะต้องกรอกข้อมูลที่เป็นความจริงทุกประการ ทั้งชื่อ
            นามสกุล เบอร์โทรศัพท์ อีเมล และ รหัสไปรษณีย์ หากท่านให้ข้อมูลที่เป็นเท็จ
            หรือข้อมูลที่ก่อให้เกิดการเข้าใจผิด เช่น อีเมลที่ไม่มีอยู่จริง
            บริษัทขอสงวนสิทธิ์ในการยกเลิกการลงทะเบียน และ สิทธิ์ชิงโชค
            โดยมิต้องแจ้งให้ทราบล่วงหน้า ซึ่งสามารถลงทะเบียนได้ที่เมกาบางนาแอปพลิเคชั่น
          </p>
          
          <p>
            2.
            สงวนสิทธิ์ร่วมรายการเฉพาะลูกค้าที่ลงทะเบียนผ่านเมกาบางนาแอปพลิเคชั่นเท่านั้น
          </p>
          
          <p>
            3. ในการลงทะเบียนเพื่อร่วมรายการ 1 ท่าน สามารถใช้ 1
            หมายเลขโทรศัพท์เพื่อเข้าร่วมชิงโชคเท่านั้น
          </p>
          
          <p>4. สำหรับเงื่อนไขการเข้าร่วมชิงโชค มีรายละเอียดดังนี้</p>
          
          <p class="pl-1">4.1 เงื่อนไขการรับสิทธิ์ชิงโชค</p>
          
          <p class="pl-2">
            4.1.1 ระหว่างวันที่ 1 พฤศจิกายน – 31 ธันวาคม 2563 ลูกค้าที่เป็นสมาชิกเมกา
            สไมล์ รีวอร์ดส สามารถช้อปสินค้าหรือใช้บริการสุทธิหลังหักส่วนลด ณ
            ร้านที่ร่วมรายการในศูนย์การค้าเมกาบางนา ทุกๆ 500 บาท รับสิทธิ์ชิงโชค 1 สิทธิ์
            จำกัดสูงสุด 200 สิทธิ์ / วัน / สมาชิก ผ่านเมกาบางนาแอปพลิเคชั่น
          </p>
          
          <p class="pl-2">
            4.1.2 ระหว่างวันที่ 1 – 30 พฤศจิกายน 2563
            สำหรับลูกค้าที่ช้อปผ่านบัตรเครดิตกรุงศรี เมื่อซื้อสุทธิหลังหักส่วนลดทุกๆ 500
            บาท รับสิทธิ์ชิงโชค 2 สิทธิ์ จำกัดสูงสุด 200 สิทธิ์ / วัน / สมาชิก
            ผ่านเมกาบางนาแอปพลิเคชั่น
          </p>
          
          <p class="pl-2">
            4.1.3 ระหว่างวันที่ 1 – 31 ธันวาคม 2563 สำหรับลูกค้าที่ช้อปผ่านบัตรเครดิต
            Citibank เมื่อซื้อสุทธิหลังหักส่วนลดทุกๆ 500 บาท รับสิทธิ์ชิงโชค 2 สิทธิ์
            จำกัดสูงสุด 200 สิทธิ์ / วัน / สมาชิก ผ่านเมกาบางนาแอปพลิเคชั่น
          </p>
          
          <p class="pl-2">
            4.1.4 สมาชิกเมกา สไมล์ รีวอร์ดส สามารถใช้ 1 คะแนน แลกรับสิทธิ์ชิงโชคได้ 1
            สิทธิ์ โดยกดแลกรับสิทธิ์ภายในเมกาบางนาแอปพลิเคชั่น ในหน้าแคมเปญ Mega Wish
          </p>
          
          <p class="pl-2">
            4.1.5 บริษัทขอเปลี่ยนแปลงเงื่อนไข วิธีการของการร่วมรายการ “Mega Wish”
            โดยมิต้องแจ้งให้ทราบล่วงหน้า ในกรณีที่มีข้อผิดพลาดที่เกิดจากระบบ
            หรือหากมีข้อพิพาทอันเนื่องมาจากการร่วมรายการ การพิจารณา
            และคำตัดสินของบริษัทถือเป็นที่สุด
          </p>
          
          <p class="pl-2">
            4.1.6 ระยะเวลาการรับสิทธิ์ชิงโชค 1 พฤศจิกายน – 31 ธันวาคม 2563
            (สิ้นสุดการรับสิทธิ์ชิงโชค ณ เวลา 22.00 น.)
          </p>
          <p class="pl-2">
            4.1.7 ในการเข้าร่วมรายการ ให้ถือว่าผู้ร่วมรายการตกลงยอมรับเงื่อนไข
            และข้อตกลงใดๆ ที่เกี่ยวข้องเป็นที่เรียบร้อยแล้ว
          </p>
          <p class="pl-2">
            4.1.8 รูปภาพของรางวัลในสื่อโฆษณา เป็นเพียงภาพจำลองเพื่อใช้ในการโฆษณาเท่านั้น
          </p>
          <p class="pl-2">
            4.1.9 พนักงานร้านค้าในศูนย์การค้าเมกาบางนา ไม่สามารถเข้าร่วมรายการได้
          </p>
          <p class="pl-2">
            4.1.10
            บริษัทขอสงวนสิทธิ์ในการเรียกคืนสิทธิประโยชน์ทุกประเภทที่สมาชิกได้รับจากการใช้คะแนนสะสมไปแล้ว
          </p>
          <p class="pl-1">4.2 รายละเอียดของรางวัล</p>
          <p class="pl-1">
            รวมของรางวัลตลอดรายการทั้งสิ้น 31 รางวัล รวมมูลค่าทั้งสิ้น 1,202,100 บาท (
            หนึ่งล้านสองแสนสองพันหนึ่งร้อยบาท )
          </p>
          <p class="pl-2">
            4.2.1 รางวัลที่ 1 กล้อง LEICA Q2 Black มูลค่า 179,200 บาท จำนวน 2 รางวัล
            มูลค่ารวม 358,400 บาท
          </p>
          <p class="pl-2">
            4.2.2 รางวัลที่ 2 Ipad Pro รุ่น 12.9 นิ้ว พร้อม Wifi + Cellular 1TB มูลค่า
            57,400 บาท จำนวน 3 รางวัล มูลค่ารวม 172,200 บาท
          </p>
          <p class="pl-2">
            4.2.3 รางวัลที่ 3 ลำโพง JBL BAR 5.1 มูลค่า 40,000 บาท จำนวน 3 รางวัล มูลค่ารวม
            120,000 บาท
          </p>
          <p class="pl-2">
            4.2.4 รางวัลที่ 4 สกู๊ตเตอร์ไฟฟ้า รุ่น MAX จาก Segway Ninebot มูลค่า 29,900
            บาท จำนวน 3 รางวัล มูลค่ารวม 89,700 บาท
          </p>
          <p class="pl-2">
            4.2.5 รางวัลที่ 5 เครื่องดูดฝุ่น Dyson รุ่น V11 Absolute+ มูลค่า 27,900 บาท
            จำนวน 3 รางวัล มูลค่ารวม 83,700 บาท
          </p>
          <p class="pl-2">
            4.2.6 รางวัลที่ 6 เครื่องฟอกอากาศ Dyson รุ่น Pure Cool™ air purifier tower fan
            TP04 มูลค่า 27,900 บาท จำนวน 3 รางวัล มูลค่ารวม 83,700 บาท
          </p>
          <p class="pl-2">
            4.2.7 รางวัลที่ 7 เครื่องชงกาแฟ Nespresso รุ่น Creatista Plus Metal Stainless
            Steel พร้อมกาแฟแคปซูล1 กล่อง มูลค่า 26,000 บาท จำนวน 5 รางวัล มูลค่ารวม
            130,000 บาท
          </p>
          <p class="pl-2">
            4.2.8 รางวัลที่ 8 ลำโพง Marshall รุ่น Stanmore II Voice with Google Assistant
            มูลค่า 19,900 บาท จำนวน 3 รางวัล มูลค่ารวม 59,700 บาท
          </p>
          <p class="pl-2">
            4.2.9 รางวัลที่ 9 ชุดอุปกรณ์จัดแต่งทรงผม Dyson รุ่น Airwrap Complete มูลค่า
            17,900 บาท จำนวน 3 รางวัล มูลค่ารวม 53,700 บาท
          </p>
          <p class="pl-2">
            4.2.10 รางวัลที่ 10 กล้อง GoPro รุ่น Max มูลค่า 17,000 บาท จำนวน 3 รางวัล
            มูลค่ารวม 51,000 บาท
          </p>
          <p class="pl-1">4.3 เงื่อนไขของรางวัล</p>
          <p class="pl-2">4.3.1 ของรางวัลไม่สามารถแลกเปลี่ยน หรือทอนเป็นเงินสดได้</p>
          <p class="pl-2">
            4.3.2 สงวนสิทธิ์ 1 รางวัล / 1 ท่าน โดยพิจารณาจากรางวัลที่ได้รับมูลค่าสูงที่สุด
          </p>
          <p class="pl-2">
            4.3.3 ผู้ที่ได้รับรางวัลที่มีมูลค่าตั้งแต่ 1,000 บาทขึ้นไป จะต้องชำระภาษีหัก ณ
            ที่จ่าย 5% ของมูลค่าของรางวัลที่ได้รับ และเป็นผู้ชำระค่าธรรมเนียมโอน
            และค่าใช้จ่ายต่างๆอันเกิดจากการรับรางวัล
          </p>
          <p class="pl-2">4.3.4 รางวัลไม่สามารถโอนสิทธิ์ให้ผู้อื่นได้</p>
          <p class="pl-2">
            4.3.5 ในการรับรางวัล ผู้โชคดีต้องมารับรางวัลด้วยตนเอง
            และบริษัทจะไม่จัดส่งของรางวัลไปให้ยังที่อยู่ของผู้โชคดี ทั้งนี้
            บริษัทจะไม่รับผิดชอบค่าจัดส่งของรางวัล หรือ ค่าใช้จ่ายใดๆ อื่นๆ ที่เกิดขึ้น
          </p>
          <p class="pl-2">
            4.3.6
            ผู้ได้รับรางวัลจำเป็นต้องนำบัตรประจำตัวประชาชนตัวจริงที่ยังไม่หมดอายุพร้อมสำเนามาเป็นหลักฐานในการรับรางวัล
            ในกรณีที่ผู้ได้รับรางวัลอายุต่ำกว่า 15 ปีบริบูรณ์
            จำเป็นต้องนำสูติบัตรฉบับจริงหรือบัตรประจำตัวประชาชนที่ยังไม่หมดอายุ
            มาแสดงโดยให้มาพร้อมบิดาหรือมารดา หรือผู้ปกครอง (บิดาหรือมารดา
            หรือผู้ปกครองจำเป็นต้องนำบัตรประจำตัวประชาชนที่ยังไม่หมดอายุมาแสดงด้วย)
          </p>
          <p class="pl-2">
            4.3.7 หากผู้ได้รับรางวัลไม่เดินทางมารับของรางวัลตามระยะเวลาที่กำหนด หรือภายใน
            30 วัน นับจากวันที่ประกาศผลจะถือว่าสละสิทธิ์
          </p>
          <p class="pl-2">4.3.10 การพิจารณา และตัดสินของบริษัท ถือเป็นที่สิ้นสุด</p>
          <p class="pl-2">
            4.3.11 หากตรวจสอบได้ว่าการกระทำของบุคคลใดมีการทุจริต
            บริษัทจะถือว่าการดำเนินการใดๆ
            และการเข้าร่วมรายการของบุคคลที่ทุจริตนั้นเป็นโมฆะทุกกรณี
          </p>
          <p class="pl-2">
            4.3.12
            บริษัทขอสงวนสิทธิ์การเปลี่ยนแปลงข้อกำหนดและเงื่อนไขโดยไม่ต้องแจ้งให้ทราบล่วงหน้า
            คำตัดสินของบริษัทถือเป็นที่สิ้นสุด
          </p>
          <p class="pl-2">
            4.3.13 สอบถามข้อมูลเพิ่มเติม โทร. 02-105-1000 (จันทร์ – ศุกร์ ตั้งแต่เวลา
            10.00 น. – 18.00 น.)
          </p>
          <p class="pl-2">
            4.3.14
            ตรวจสอบยอดสิทธิ์ชิงโชคได้โดยสามารถตรวจสอบยอดสิทธิ์ชิงโชคที่เมกาบางนาแอปพลิเคชั่น
          </p>
          <p class="pl-1">4.4 เงื่อนไขการจับรางวัล</p>
          <p class="pl-1">
            ทำการจับรางวัลโดยบริษัท เอสเอฟ ดีเวลอปเมนท์ จำกัด ที่อยู่ 38 , 38/1-3, 39 หมู่
            6 ถนนบางนา-ตราด ตำบลบางแก้ว อำเภอบางพลี สมุทรปราการ 10540 ในวันที่ 8 ม.ค. 64 ณ
            สำนักงานเมกาบางนา และประกาศรางวัลวันที่ 15 ม.ค. 64 ผ่านทาง www.mega-bangna.com
            และ Facebook : MegabangnaShoppingcenter
          </p>
          <p><b>นโยบายความเป็นส่วนตัว</b></p>
          <p>
            &emsp;บริษัทได้จัดทำนโยบายความเป็นส่วนตัวเพื่อเป็นการป้องกันข้อมูลส่วนบุคคลของผู้ลงทะเบียนเข้าร่วม
            รายการ “Mega Wish” ซึ่งมีรายละเอียดดังนี้
          </p>
          <p>
            &emsp;ก่อนการร่วมรายการ
            ท่านจะต้องลงทะเบียนก่อนโดยใส่ข้อมูลตามจริงและตกลงยินยอมให้ข้อมูลแก่บริษัท
            เอสเอฟ ดีเวลอปเมนท์ จำกัด และผู้ที่ได้รับมอบหมายจากบริษัท
            หรือคู่สัญญาทางธุรกิจอื่นๆ ทั้งนี้ ผู้ที่ได้รับมอบหมายจากบริษัท
            หรือคู่สัญญาทางธุรกิจอื่นๆอาจะใช้ข้อมูลทั้งหมดหรือบางส่วน
            เพื่อวัตถุประสงค์ทางการตลาด และ การพัฒนาโปรแกรม
            รวมถึงวัตถุประสงค์ใดๆตามที่บริษัทเห็นสมควร
          </p>
          `
		},
		rangeDate: '1 พ.ย. - 31 ธ.ค.2563',
		titlePrice: 'ลุ้นของรางวัล รับเทศกาลแห่งความสุข',
		titleSumPrice: 'รวม 31 รางวัล มูลค่ากว่า 1.2 ล้านบาท',
		titlePriceCondition: 'เมื่อช้อปครบตามเงื่อนไขที่กำหนด',
		seeDetail: 'ดูรายละเอียดของรางวัล',
		textUnit: 'สิทธิ์',
		textPriceUnit: ' คะแนน = 1 สิทธิ์',
		otherCondition: 'เงื่อนไขเพิ่มเติม'
	}
};
